import React, { useRef, useState } from 'react';
import { Text } from '@ui';
import { translate } from '@utils/i18n';
import { IIM_BUCKET_FILTER_EVENT } from '../../events';
import { activateIssuesTab } from '../../utils/activateIssuesTab';
import { BUCKET_ISSUE_TYPES } from './bucketIssueTypes';
import './IssueTypeBucketStyles.scss';
const NS = 'features.iim_review.issues_grid.buckets';
const ISSUE_TYPE_LABELS_NS = 'features.iim_review.issues_grid.issue_type_labels';
const CHECK_DISPLAY_MS = 1200;
const ACTIVATION_KEYS = [' ', 'Enter'];
function buildBreakdown(bucketKey, typeCounts, assetCountChangeDetail) {
    var _a;
    const issueTypes = (_a = BUCKET_ISSUE_TYPES[bucketKey]) !== null && _a !== void 0 ? _a : [];
    return issueTypes
        .filter((issueType) => { var _a; return ((_a = typeCounts === null || typeCounts === void 0 ? void 0 : typeCounts[issueType]) !== null && _a !== void 0 ? _a : 0) > 0; })
        .map((issueType) => {
        var _a;
        if (issueType === 'asset_count_change' && assetCountChangeDetail) {
            return translate('asset_count_change_detail', {
                namespace: NS,
                priorCount: assetCountChangeDetail.priorCount,
                currentCount: assetCountChangeDetail.currentCount,
                sinceDate: assetCountChangeDetail.sinceDate,
                defaultValue: 'asset count went %{priorCount} to %{currentCount} since %{sinceDate}'
            });
        }
        const label = translate(issueType, { namespace: ISSUE_TYPE_LABELS_NS, defaultValue: issueType });
        return `${(_a = typeCounts === null || typeCounts === void 0 ? void 0 : typeCounts[issueType]) !== null && _a !== void 0 ? _a : 0} ${label.toLowerCase()}`;
    })
        .join(', ');
}
function IssueTypeBucket({ bucketKey, count, totalCount, typeCounts, technician, assetCountChangeDetail }) {
    const [checked, setChecked] = useState(false);
    const checkTimer = useRef(null);
    const handleClick = () => {
        var _a;
        const issueTypes = (_a = BUCKET_ISSUE_TYPES[bucketKey]) !== null && _a !== void 0 ? _a : [];
        const detail = { issueTypes, bucketKey, count, totalCount };
        document.dispatchEvent(new CustomEvent(IIM_BUCKET_FILTER_EVENT, { detail }));
        activateIssuesTab();
        if (checkTimer.current)
            clearTimeout(checkTimer.current);
        setChecked(true);
        checkTimer.current = setTimeout(() => setChecked(false), CHECK_DISPLAY_MS);
    };
    const handleKeyDown = (event) => {
        if (event.target !== event.currentTarget)
            return;
        if (!ACTIVATION_KEYS.includes(event.key))
            return;
        event.preventDefault();
        handleClick();
    };
    const label = translate(bucketKey, { namespace: NS, defaultValue: bucketKey });
    const breakdown = buildBreakdown(bucketKey, typeCounts, assetCountChangeDetail);
    return (React.createElement("div", { className: "issue-type-bucket", role: "button", tabIndex: 0, "aria-pressed": checked, onClick: handleClick, onKeyDown: handleKeyDown },
        React.createElement("span", { className: "issue-type-bucket__content" },
            React.createElement(Text, { variant: "x-small", as: "span", className: "issue-type-bucket__label" }, label),
            React.createElement("span", { className: "issue-type-bucket__subline" },
                React.createElement(Text, { variant: "x-small", as: "span", className: "issue-type-bucket__count" }, translate('issue_count', { namespace: NS, count, defaultValue: '%{count} issues' })),
                breakdown && (React.createElement(Text, { variant: "body", as: "span", className: "issue-type-bucket__breakdown" },
                    translate('item_separator', { namespace: NS, defaultValue: ' · ' }),
                    breakdown)),
                technician && (React.createElement(Text, { variant: "body", as: "span", className: "issue-type-bucket__technician" },
                    translate('item_separator', { namespace: NS, defaultValue: ' · ' }),
                    React.createElement("span", { className: "issue-type-bucket__technician-name" }, technician.name))))),
        React.createElement("span", { className: "issue-type-bucket__meta" },
            React.createElement("i", { className: `fa-light ${checked ? 'fa-check issue-type-bucket__check-icon' : 'fa-chevron-right issue-type-bucket__chevron-icon'}`, "aria-hidden": "true" }))));
}
export default IssueTypeBucket;
